import { useEffect, useState } from 'react';

export function usePagination<T>(items: T[], itemsPerPage: number = 3) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil((items || []).length / itemsPerPage));

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [items?.length, totalPages, page]);

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = (items || []).slice(startIndex, endIndex);

  const handlePrev = () => {
    setPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setPage((prev) => Math.min(prev + 1, totalPages));
  };

  return {
    currentItems,
    page,
    totalPages,
    handlePrev,
    handleNext,
    isFirstPage: page === 1,
    isLastPage: page === totalPages
  };
}
